import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface RoleBasedRouteProps {
    allowedRoles: string[];
    redirectTo?: string;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ 
    allowedRoles, 
    redirectTo = '/cms/dashboard' 
}) => {
    const { authState } = useAuth();

    // Check if user is authenticated
    if (!authState.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    // Check if user has required role
    const userRole = authState.user?.role;
    if (!userRole || !allowedRoles.includes(userRole)) {
        return <Navigate to={redirectTo} replace />;
    }

    return <Outlet />;
};

export default RoleBasedRoute; 